<ng-container *ngIf="cardVide">
  <div class="h-screen pt-20">
    <h1 class="mb-10 text-center text-2xl font-bold">Shopping Cart</h1>
    <div
      class="mx-auto max-w-5xl justify-center px-6 md:flex md:space-x-6 xl:px-0"
    >
      <div class="rounded-lg md:w-2/3">
        <div
          *ngFor="let cart of cartProducts; let index = index"
          class="mb-6 rounded-lg bg-white p-6 shadow-md flex flex-col sm:flex-row sm:justify-between"
        >
          <img
            src="{{ cart.item.imageUrl }}"
            alt="product-image"
            class="w-full rounded-lg sm:w-40"
          />
          <div
            class="mt-4 sm:mt-0 sm:ml-4 sm:flex sm:w-full sm:justify-between"
          >
            <div class="flex flex-col justify-between">
              <div>
                <h2 class="text-lg font-bold text-gray-900">
                  {{ cart.item.name }}
                </h2>
                <p class="mt-1 text-xs text-gray-700">
                  Dinar {{ cart.item.price }}
                </p>
              </div>
              <div class="mt-4 flex items-center border-gray-100">
                <span
                  class="cursor-pointer rounded-l bg-gray-100 py-1 px-3.5 duration-100 hover:bg-blue-500 hover:text-blue-50"
                  (click)="decreaseQuantity(index)"
                  >-</span
                >
                <input
                  class="h-8 w-8 border bg-white text-center text-xs outline-none"
                  type="number"
                  [(ngModel)]="cart.quantity"
                  min="1"
                />
                <span
                  class="cursor-pointer rounded-r bg-gray-100 py-1 px-3.5 duration-100 hover:bg-blue-500 hover:text-blue-50"
                  (click)="increaseQuantity(index)"
                  >+</span
                >
              </div>
            </div>
            <div
              class="mt-4 sm:mt-0 flex sm:items-end sm:justify-end justify-between space-x-5"
            >
              <p class="sm:text-lg">
                Dinar {{ (cart.item.price * cart.quantity).toFixed(2) }}
              </p>
              <svg
                (click)="deleteProduct(index)"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                class="h-7 w-7 cursor-pointer duration-150 hover:text-red-500"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <!-- Sub total -->
      <div
        class="mt-6 h-full rounded-lg border bg-white p-6 shadow-md md:mt-0 md:w-1/3"
      >
        <div class="mb-2 flex justify-between">
          <p class="text-gray-700">Subtotal</p>
          <p class="text-gray-700"> {{ totalPrice.toFixed(2) }}</p>
        </div>
        <div class="flex justify-between">
          <p class="text-gray-700">Shipping</p>
          <p class="text-gray-700"> 9.99</p>
        </div>
        <hr class="my-4" />
        <div class="flex justify-between">
          <p class="text-lg font-bold">Total</p>
          <div class="">
            <p class="mb-1 text-lg font-bold">
              Dinar {{ (totalPrice + 9.99).toFixed(2) }}
            </p>
          </div>
        </div>
        <button
          class="mt-6 w-full rounded-md bg-blue-500 py-1.5 font-medium text-blue-50 hover:bg-blue-600"
          (click)="order()"
        >
          Check out
        </button>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!cardVide">
  <div class="flex justify-center items-center h-screen w-screen">
    <iframe
      src="https://lottie.host/embed/45b16109-e5b6-4739-aad7-e906dd4206e1/uGGYy5nzlS.json"
      class="w-full h-full max-w-4xl max-h-4xl"
    ></iframe>
  </div>
</ng-container>
